<template>
	<div />
</template>

<script>
	import Names from '@/router/names';
	import { reviveChatSession } from '@/services/chat/chatSession';
	import { followChatLink } from '@/services/chat/chatStore';

	export default {
		name: 'NotificationLanding',
		created() {
			const { chat, typeId, docId, key, notificationType, body, orderId } = this.$route.query;
			if (chat === '1') {
				followChatLink({ typeId, docId, key, notificationType, body });
				reviveChatSession(this.$store);
			} else if (orderId && orderId !== 'undefined') {
				this.emitter.emit('onNewOrderReceived', { orderId });
			}
			this.$router.replace({ name: Names.OrdersKanban });
		},
	};
</script>

<style scoped></style>
